import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLivePaidEmdOffer } from "../../../../../../redux/action/liveRoom";
import { useNavigate, useParams } from "react-router-dom";
import {
  calculateRemainingTime,
  formatTime,
} from "../../../../../../helpers/helpers";

function LiveRoomHeader() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profile } = useSelector((state) => state?.profileStore);
  const { ListLoadings, paidEmdOfferData } = useSelector(
    (state) => state.liveAuctionList
  );
  const [remainingTime, setRemainingTime] = useState(
    calculateRemainingTime(
      paidEmdOfferData?.auction?.auctionSchedule?.endingTime
    )
  );

  const refershInLiveRoom = () => {
    dispatch(getLivePaidEmdOffer(id));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const newRemainingTime = calculateRemainingTime(
        paidEmdOfferData?.auction?.auctionSchedule?.endingTime
      );
      setRemainingTime(newRemainingTime);
      if (formatTime(newRemainingTime) <= "00:00:00") {
        navigate("/thanks-for-participation");
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [paidEmdOfferData, navigate]);

  return (
    <div
      className="p-1 valign-wrapper space-between flex-wrap gap-1"
      style={{ backgroundColor: "#ff7900", borderRadius: "5px" }}
    >
      <span className="white-text font-18px valign-wrapper gap-10px">
        <h6 className="font-18px margin-0px">Welcome</h6>
        <h6 className="font-16px margin-0px">{profile?.email}</h6>
      </span>
      <span className="valign-wrapper gap-2">
        <h6 className="font-16px white-text">
          Auction Time : {formatTime(remainingTime)}
        </h6>
        <button
          className="flex align-center reload-btn"
          style={{ height: "35px", backgroundColor: "white", color: "red" }}
          onClick={() => window.close()}
        >
          <span className="material-symbols-outlined">exit_to_app</span>
        </button>
        <button
          className="flex align-center reload-btn  "
          disabled={ListLoadings}
          onClick={refershInLiveRoom}
          style={{ height: "35px" }}
        >
          <span className="material-symbols-outlined">autorenew</span>
        </button>
      </span>
    </div>
  );
}

export default LiveRoomHeader;
